import Vue from 'vue'
import Router from 'vue-router'

const Header = resolve => require(['@/components/common/header/header'], resolve)
const Footer = resolve => require(['@/components/common/footer/foote'], resolve)
const Sidebar = resolve => require(['@/components/common/sidebar/sidebar'], resolve)
const Login = resolve => require(['@/components/Login.vue'], resolve)
const Register = resolve => require(['@/components/Register.vue'], resolve)
const CustomerInfo = resolve => require(['@/components/CustomerInfo.vue'], resolve)
const AddCustomer = resolve => require(['@/components/AddCustomer.vue'], resolve)
const MarketContactor = resolve => require(['@/components/MarketContactor.vue'], resolve)

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/jr/broker/',
  routes: [
    {
      path: '/',
      components: {
        default: Login,
        header: Header,
        footer: Footer
      }
    },
    {
      path: '/register',
      components: {
        default: Register,
        header: Header,
        footer: Footer
      }
    },
    {
      path: '/info',
      components: {
        default: CustomerInfo,
        header: Header,
        sidebar: Sidebar,
        footer: Footer
      }
    },
    {
      path: '/add',
      components: {
        default: AddCustomer,
        header: Header,
        sidebar: Sidebar,
        footer: Footer
      }
    },
    {
      path: '/market',
      components: {
        default: MarketContactor,
        header: Header,
        sidebar: Sidebar,
        footer: Footer
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js